import HttpClientToken from '../../services/HttpClientToken';

import { AxiosError } from 'axios';

import { defaultHttpResponse, HttpResponse, CambiarContrasenaParams } from '../../interfaces/auth/AuthInterface';

import { ActualizarConfiguracionUsuarioParams, ActualizarMecanografosUsuarioParams, ActualizarPermisosUsuarioParams, ActualizarUsuarioParams, AgregarUsuarioParams, BuscarUsuarioPoderEnLineaParams, BuscarUsuarioPoderEnLineaResponse, BuscarUsuarioResponse, defaultBuscarUsuario, defaultBuscarUsuarioPoderEnLinea, defaultPerfil, defaultUsuario, MecanografoProps, PerfilProps, UsuarioAcuerdoProps, UsuarioCertificacionProps, UsuarioDelegadoProps, UsuarioExhortoLibradoProps, UsuarioJuezProps, UsuarioMecanografoProps, UsuarioNotificacionProps, UsuarioOficiosProps, UsuarioProps, UsuarioReasignacionCancelacionResponse, UsuarioResponse, UsuarioSecretarioProps } from '../../interfaces/admin/UsuarioInterface';

export const Usuarios = () => {

    return new Promise<UsuarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/', token)
            .then( ({ data } : { data : UsuarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarUsuario = ( params: ActualizarUsuarioParams ) => {

    return new Promise<UsuarioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/ActualizarUsuario', params, token)
            .then( ({ data } : { data : UsuarioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultUsuario, message: error.message } );
            });

        }

    });

}

export const ActualizarConfiguracionUsuario = ( params: ActualizarConfiguracionUsuarioParams ) => {

    return new Promise<UsuarioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/ActualizarConfiguracionUsuario', params, token)
            .then( ({ data } : { data : UsuarioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultUsuario, message: error.message } );
            });

        }

    });

}

export const ActualizarPermisosUsuario = ( params: ActualizarPermisosUsuarioParams ) => {

    return new Promise<UsuarioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/ActualizarPermisosUsuario', params, token)
            .then( ({ data } : { data : UsuarioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultUsuario, message: error.message } );
            });

        }

    });

}

export const AgregarUsuario = ( params: AgregarUsuarioParams ) => {

    return new Promise<UsuarioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/AgregarUsuario', params, token)
            .then( ({ data } : { data : UsuarioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultUsuario, message: error.message } );
            });

        }

    });

}

export const BuscarUsuarioRH = ( curp: string ) => {

    return new Promise<BuscarUsuarioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Usuario/BuscarUsuario/${ curp }`, token)
            .then( ({ data } : { data : BuscarUsuarioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultBuscarUsuario, message: error.message } );
            });

        }

    });

}

export const BuscarUsuariosDelegados = () => {

    return new Promise<UsuarioDelegadoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosDelegados', token)
            .then( ({ data } : { data : UsuarioDelegadoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const CambiarContrasena = ( params: CambiarContrasenaParams ) => {

    return new Promise<HttpResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/CambiarContrasena/', params, token)
            .then( ({ data } : { data : HttpResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultHttpResponse, message: error.message } );
            });

        }

    });

}

export const ObtenerPerfil = () => {

    return new Promise<PerfilProps>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/ObtenerPerfil/', null, token)
            .then( ({ data } : { data : PerfilProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultPerfil } );
            });

        }

    });

}

export const ObtenerUsuariosReasignacionCancelacion = () => {

    return new Promise<UsuarioReasignacionCancelacionResponse[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/ObtenerUsuariosReasignacionCancelacion', token)
            .then( ({ data } : { data : UsuarioReasignacionCancelacionResponse[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerUsuarioJuez = () => {

    return new Promise<UsuarioJuezProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/ObtenerUsuarioJuez', token)
            .then( ({ data } : { data : UsuarioJuezProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerSecretarioMecanografo = () => {

    return new Promise<UsuarioMecanografoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/ObtenerSecretarioMecanografo', token)
            .then( ({ data } : { data : UsuarioMecanografoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuarioPoderEnLinea = ( params: BuscarUsuarioPoderEnLineaParams ) => {

    return new Promise<BuscarUsuarioPoderEnLineaResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/BuscarUsuarioPoderEnLinea', params, token)
            .then( ({ data } : { data : BuscarUsuarioPoderEnLineaResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve({ ...defaultBuscarUsuarioPoderEnLinea });
            });

        }

    });

}

export const ActualizarMecanografosUsuario = ( params: ActualizarMecanografosUsuarioParams ) => {

    return new Promise<UsuarioResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/Usuario/ActualizarMecanografosUsuario', params, token)
            .then( ({ data } : { data : UsuarioResponse } ) => {
                resolve( data );
            })
            .catch( ( error: AxiosError ) => {
                resolve( { ...defaultUsuario, message: error.message } );
            });

        }

    });

}

export const ObtenerMecanografos = ( id: number ) => {

    return new Promise<MecanografoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get(`/Api/Usuario/ObtenerMecanografos/${ id }`, token)
            .then( ({ data } : { data : MecanografoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarSecretariosAudiencias = () => {

    return new Promise<UsuarioSecretarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarSecretariosAudiencias', token)
            .then( ({ data } : { data : UsuarioSecretarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarSecretariosAdmisibilidad = () => {

    return new Promise<UsuarioSecretarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarSecretariosAdmisibilidad', token)
            .then( ({ data } : { data : UsuarioSecretarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarSecretariosTramite = () => {

    return new Promise<UsuarioSecretarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarSecretariosTramite', token)
            .then( ({ data } : { data : UsuarioSecretarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarSecretariosTramiteMenor = () => {

    return new Promise<UsuarioSecretarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarSecretariosTramiteMenor', token)
            .then( ({ data } : { data : UsuarioSecretarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarSecretariosEjecucion = () => {

    return new Promise<UsuarioSecretarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarSecretariosEjecucion', token)
            .then( ({ data } : { data : UsuarioSecretarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarSecretariosIrregular = () => {

    return new Promise<UsuarioSecretarioProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarSecretariosIrregular', token)
            .then( ({ data } : { data : UsuarioSecretarioProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosAcuerdo = () => {

    return new Promise<UsuarioAcuerdoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosAcuerdo', token)
            .then( ({ data } : { data : UsuarioAcuerdoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosOficiosElaboro = () => {

    return new Promise<UsuarioOficiosProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosOficiosElaboro', token)
            .then( ({ data } : { data : UsuarioOficiosProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosOficiosAsignacion = () => {

    return new Promise<UsuarioOficiosProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosOficiosAsignacion', token)
            .then( ({ data } : { data : UsuarioOficiosProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosExhortoLibradoElaboro = () => {

    return new Promise<UsuarioExhortoLibradoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosExhortoLibradoElaboro', token)
            .then( ({ data } : { data : UsuarioExhortoLibradoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosExhortoLibradoAsignacion = () => {

    return new Promise<UsuarioExhortoLibradoProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosExhortoLibradoAsignacion', token)
            .then( ({ data } : { data : UsuarioExhortoLibradoProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosNotificacion = () => {

    return new Promise<UsuarioNotificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosNotificacion', token)
            .then( ({ data } : { data : UsuarioNotificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosCertificacionElaboro = () => {

    return new Promise<UsuarioCertificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosCertificacionElaboro', token)
            .then( ({ data } : { data : UsuarioCertificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const BuscarUsuariosCertificacionAsignacion = () => {

    return new Promise<UsuarioCertificacionProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/Usuario/BuscarUsuariosCertificacionAsignacion', token)
            .then( ({ data } : { data : UsuarioCertificacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}
